import {
  getFromLocalStorage,
  getFromSessionStorage,
  removeInLocalStorage,
  removeInSessionStorage,
  setInLocalStorage,
  setInSessionStorage,
} from '@delmonicos/shared-sdk/libs/core/src/helpers/storage.utils';

import { JWT_LSK, REFRESH_LSK } from 'src/config/storage-keys';

export interface RefreshTokenStorage {
  refreshToken: string;
  wasRemembered: boolean;
}

export abstract class InAppStorage {
  public static get jwt(): string | null {
    return (
      getFromLocalStorage<string | null>(JWT_LSK, null) ??
      getFromSessionStorage<string | null>(JWT_LSK, null)
    );
  }

  public static get refreshToken(): RefreshTokenStorage | null {
    let refreshToken = getFromLocalStorage<string | null>(REFRESH_LSK, null);
    if (refreshToken) {
      return { refreshToken, wasRemembered: true };
    }
    refreshToken = getFromSessionStorage<string | null>(REFRESH_LSK, null);
    if (refreshToken) {
      return { refreshToken, wasRemembered: false };
    }
    return null;
  }

  public static setJwt(value: string | null, rememberMe: boolean): void {
    if (value === null) {
      removeInLocalStorage(JWT_LSK);
      removeInSessionStorage(JWT_LSK);
      return;
    }

    if (rememberMe) {
      setInLocalStorage(JWT_LSK, value);
      removeInSessionStorage(JWT_LSK);
    } else {
      setInSessionStorage(JWT_LSK, value);
      removeInLocalStorage(JWT_LSK);
    }
  }

  public static setRefreshToken(
    value: string | null,
    rememberMe: boolean,
  ): void {
    if (value === null) {
      removeInLocalStorage(REFRESH_LSK);
      removeInSessionStorage(REFRESH_LSK);
      return;
    }

    if (rememberMe) {
      setInLocalStorage(REFRESH_LSK, value);
      removeInSessionStorage(REFRESH_LSK);
    } else {
      setInSessionStorage(REFRESH_LSK, value);
      removeInLocalStorage(REFRESH_LSK);
    }
  }
}
